var React = require('react');

function IconRemoveInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon-remove-inline"),React.createElement("path",{"d":"M12.35,10l7.16-7.15A1.67,1.67,0,1,0,17.14.49L10,7.65,2.86.49A1.67,1.67,0,0,0,.49,2.85L7.65,10,.49,17.14a1.68,1.68,0,0,0,0,2.36h0a1.68,1.68,0,0,0,2.36,0h0L10,12.35l7.14,7.16a1.68,1.68,0,0,0,2.36,0h0a1.68,1.68,0,0,0,0-2.36h0Z","fill":"#f4c34a","key":1})]);
}

IconRemoveInline.defaultProps = {"id":"remove","width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = IconRemoveInline;

IconRemoveInline.default = IconRemoveInline;
